import React from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { useMediaQuery } from "react-responsive";

import classes from "./index.module.scss";
import { isEmpty } from "lodash";
import HomePageTitle from '../../assets/HomePageTitleNew.png'

function HomePageContentHeader(props) {
    const {
        buttonTitle = "",
        footerTitle = "",
        redirectTo = "",
        showBtnBg = true,
        onButtonClick = () => { },
    } = props || {};
    const isMobileOrTablet = useMediaQuery({
        query: "(max-device-width: 540px)",
    });

    const renderHeaderFooter = () => {
        if (isMobileOrTablet) {
            return (
                <>
                    {footerTitle && <p className={classes.p2}>{footerTitle}</p>}
                    {buttonTitle && (
                        <Link
                            to={redirectTo}
                            className={`${classes.header_btn} ${showBtnBg && classes.header_btn_bg
                                }`}
                        >
                            {buttonTitle}
                        </Link>
                    )}
                </>
            );
        }

        return (
            <>
                {buttonTitle && isEmpty(redirectTo) ? (
                    <Link
                        className={`${classes.header_btn} ${showBtnBg && classes.header_btn_bg
                            }`}
                        onClick={onButtonClick}
                    >
                        {buttonTitle}
                    </Link>
                ) : (
                    buttonTitle &&
                    isEmpty(redirectTo) && (
                        <Link
                            to={redirectTo}
                            className={`${classes.header_btn} ${showBtnBg && classes.header_btn_bg
                                }`}
                        >
                            {buttonTitle}
                        </Link>
                    )
                )}
                {footerTitle && <p className={classes.p2}>{footerTitle}</p>}
            </>
        );
    };
    return (
        <section className={classes.root}>
            <div className={classes.container}>
                <div className={classes.titlesWrapper}>
                    {/* <img src={HomePageTitle} alt='' className={classes.title} /> */}
                    {isMobileOrTablet ? (<p>If you could build <br/> your own <span> All-Star Team...</span><br />
                    Who would you pick?</p>) : (<><p>If you could build <br/> your own <span> All-Star Team...</span></p>
                    <p>Who would you pick?</p></>)}
                    <h4 className={classes.subtitle}>Using our Star Player ranking system, <br />
                    you can build the team you want!</h4>
                    <Link className={classes.powerBtn} to={redirectTo}>{buttonTitle || "Power Up!"}</Link>
                    <p className={classes.haveAccount}>Already have an account? <Link to="/login">Login</Link> </p>
                </div>
                {/* <p className={classes.blogSection}>*International Patents Pending</p> */}
            </div>
        </section>
    );
}

HomePageContentHeader.propTypes = {
    buttonTitle: PropTypes.string,
    redirectTo: PropTypes.string,
    footerTitle: PropTypes.any,
    showBtnBg: PropTypes.bool,
    onButtonClick: PropTypes.func,
};

export default HomePageContentHeader;
